<template>
  <ux-form
    ref="form"
    :data="formData"
    :rules="rules"
    width="440px"
    :colon="true"
    label-width="56px"
    data-automation="addUser"
  >
    <ux-form-item :label="$t('HT.addChannel.name')" prop="name">
      <ux-input
        v-model.trim()="formData.name"
        required
        :maxlength="20"
        :placeholder="$t('HT.addChannel.name.placeholder')"
      ></ux-input>
    </ux-form-item>
    <ux-form-item :label="$t('HT.addChannel.code')">
      <ux-input
        v-model.trim()="formData.code"
        disabled
        :maxlength="50"
        :placeholder="$t('HT.changeChannel.placeholder1')"
      ></ux-input>
    </ux-form-item>
    <ux-form-item :label="$t('HT.addChannel.type')">
      <ux-input v-model="formData.type" label="label" disabled></ux-input>
    </ux-form-item>
    <ux-form-item :label="$t('HT.changeChannel.priority')" prop="priority">
      <ux-input
        v-model.trim()="formData.priority"
        required
        :maxlength="4"
        :placeholder="$t('HT.changeChannel.placeholder2')"
      ></ux-input>
    </ux-form-item>
    <!-- <ux-form-item label="描述" start>
            <ux-input v-model.trim()="formData.remark" type="textarea" show-word-limit :maxlength="100" resize="none" :autosize="{minRows: 3, maxRows: 6}"></ux-input>
        </ux-form-item> -->
    <ux-form-item :label="$t('HT.addChannel.open')" prop="disabled">
      <ux-switch v-model="formData.disabled" :active-value="false" :inactive-value="true" />
    </ux-form-item>
  </ux-form>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          name: '', //名称
          code: '', // 编码
          type: '', // 类型
          priority: '', //优先级
          // remark: '', //描述
          disabled: false //启用
        };
      }
    }
  },
  data() {
    return {
      formData: JSON.parse(JSON.stringify(this.data)),
      rules: this.$rul.channel()
    };
  },
  created() {
    this.changeType();
  },
  methods: {
    changeType() {
      this.formData.type = this.$opt.switchStr(this.formData.type, this.$opt.channelType);
    }
  }
};
</script>
